import React from "react";

function Footer() {
  return (
    <footer className="bg-dark text-center py-4 footer text-light">
      <div className="container">
        <p className="mb-3">
          This article is translated from <em>Desiring God - Solid Joys</em>{" "}
          daily devotion. This is only for private circulation.
        </p>
        <p>
          Contact:{" "}
          <a
            href="mailto:isaacjdelhi@gmail.com"
            className="text-light text-decoration-underline"
          >
            isaacjdelhi@gmail.com
          </a>
        </p>
        <p className="mb-3">
          © 2025 <strong>Reformed Missional Church</strong>. All rights
          reserved.
        </p>
        <div className="d-flex justify-content-center gap-4">
          <a
            href="https://www.youtube.com/@reformedmissionalchurch"
            target="_blank"
            rel="noopener noreferrer"
            className="text-light text-decoration-none"
          >
            <i className="fab fa-youtube"></i> YouTube
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-light text-decoration-none"
          >
            <i className="fab fa-facebook"></i> Facebook
          </a>
          <a
            href="https://reformedmissionalchurch.org/#/blog"
            target="_blank"
            rel="noopener noreferrer"
            className="text-light text-decoration-none"
          >
            <i className="fas fa-blog"></i> Blog
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
